import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import useStyles from './styles';

function createData(
  viewedProduct,
) {
  return {
    viewedProduct,
  };
}

export default function SingleProduct({ viewedProduct }) {
  const [rows, setRows] = useState([]);
  const classes = useStyles();

  useEffect(() => {
    const tempArray = [];
    tempArray.push(createData(
      viewedProduct,
    ));
    setRows(tempArray);
  }, [viewedProduct]);

  return (
    <TableContainer component={Paper} className={classes.root}>
      <Table aria-label="Product info" className={classes.table}>
        <TableHead>
          <TableRow className={classes.verticalTable}>
            <TableCell variant="head">Description</TableCell>
            <TableCell>Part Number</TableCell>
            <TableCell>Drawing Number</TableCell>
            <TableCell>Product Group</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.viewedProduct.partNumber} className={classes.verticalTable}>
              <TableCell>{row.viewedProduct.description}</TableCell>
              <TableCell>{row.viewedProduct.partNumber}</TableCell>
              <TableCell>{row.viewedProduct.drawingNumber}</TableCell>
              <TableCell>{row.viewedProduct.productGroup?.number}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Table aria-label="Product info" className={classes.associationsTable}>
        <TableHead>
          <TableRow className={classes.horizontalTable}>
            <TableCell>Associated from</TableCell>
            <TableCell>Associated to</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <>
              <TableRow
                key={row.viewedProduct.drawingNumber}
                className={classes.verticalTable}
              >
                {row.viewedProduct.associatedProductGroupsFrom?.length > 0
                  ? row.viewedProduct.associatedProductGroupsFrom.map((association) => (
                    <TableCell key={association.number}>
                      {association.number}
                    </TableCell>
                  ))
                  : (
                    <TableCell>
                      -
                    </TableCell>
                  )}
              </TableRow>
              <TableRow className={classes.verticalTable}>
                {row.viewedProduct.associatedProductGroupsTo?.length > 0
                  ? row.viewedProduct.associatedProductGroupsTo.map((association) => (
                    <TableCell key={row.viewedProduct.attributesValues['@id']}>
                      {association.number}
                    </TableCell>
                  )) : (
                    <TableCell>
                      -
                    </TableCell>
                  )}
              </TableRow>
            </>
          ))}
        </TableBody>
      </Table>
      <Table aria-label="Product info" className={classes.attributesTable}>
        <TableHead>
          <TableRow className={classes.verticalTable}>
            <TableCell variant="head">Attributes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.horizontalTable}>
          {rows?.map((row) => (
            <>
              <TableRow key={row.viewedProduct.description} className={classes.verticalTable}>
                {row.viewedProduct.attributesValues?.map((attributesValues) => (
                  <TableCell>
                    {attributesValues.attribute.name}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow
                key={row.viewedProduct.attributesValues.value}
                className={classes.verticalTable}
              >
                {row.viewedProduct.attributesValues?.map((attributesValues) => (
                  <TableCell>
                    {attributesValues.value}
                  </TableCell>
                ))}
              </TableRow>
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

SingleProduct.propTypes = {
  viewedProduct: PropTypes.oneOfType(
    [PropTypes.number, PropTypes.object],
  ).isRequired,
};
